import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Add as AddIcon,
  CreditCard as CreditCardIcon,
} from "@mui/icons-material";
import TarjetaRow from "./TarjetaRow";

export default function TarjetasTab({
  tarjetas,
  onAdd,
  onUpdate,
  onRemove,
  tiposTarjeta,
  bancos,
  marcas = [],
  handleImporteChange,
}) {
  return (
    <>
      {tarjetas.length === 0 ? null : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Agregue los pagos con tarjeta de crédito o débito
          </Typography>
          <Button variant="outlined" startIcon={<AddIcon />} onClick={onAdd}>
            Agregar tarjeta
          </Button>
        </Box>
      )}

      {tarjetas.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            py: 0.5,
          }}
        >
          <CreditCardIcon
            sx={{
              fontSize: 18,
              color: "text.disabled",
            }}
          />

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: "0.82rem",
            }}
          >
            No hay pagos con tarjeta agregados
          </Typography>

          <Button
            variant="text"
            size="small"
            onClick={onAdd}
            sx={{
              minWidth: "auto",
              p: 0,
              fontSize: "0.8rem",
              textTransform: "none",
            }}
          >
            Agregar
          </Button>
        </Box>
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "grey.100" }}>
                <TableCell>
                  <strong>Tipo</strong>
                </TableCell>
                <TableCell>
                  <strong>Marca</strong>
                </TableCell>
                <TableCell>
                  <strong>Nombre Tarjeta</strong>
                </TableCell>
                <TableCell>
                  <strong>Lote</strong>
                </TableCell>
                <TableCell>
                  <strong>Cupón</strong>
                </TableCell>
                <TableCell>
                  <strong>Últimos 4</strong>
                </TableCell>
                <TableCell>
                  <strong>Importe</strong>
                </TableCell>
                <TableCell width={50}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tarjetas.map((tarjeta, index) => (
                <TarjetaRow
                  key={tarjeta.id}
                  tarjeta={tarjeta}
                  index={index}
                  tiposTarjeta={tiposTarjeta}
                  nombresTarjeta={bancos}
                  marcas={marcas}
                  onUpdate={onUpdate}
                  onRemove={onRemove}
                  handleImporteChange={handleImporteChange}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
